import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import {Calendar} from 'primereact/calendar';
import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Paginator } from 'primereact/paginator';
import { Sidebar } from 'primereact/sidebar';
import { Dialog } from 'primereact/dialog';
import QRCode from 'qrcode.react';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from 'primereact/confirmdialog';
import './PermitManagement.css';
import DeleteIcon from '../../assets/icons/delete.svg';
import { handleDeleteRequest } from '../../services/DeleteTemplate';
import { Tag } from 'primereact/tag';
import { useNavigate } from 'react-router-dom';
import SuccessLoader from '../../components/SuccessLoader';
import { saveAs } from 'file-saver';
import { baseURL } from '../../Config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handlePostRequest } from '../../services/PostTemplate';
import PermitViewSideBar from './PermitViewSideBar';
import { Dropdown } from 'primereact/dropdown';
import { handleGetRequest } from '../../services/GetTemplate';
import axios from 'axios';

function PermitManagement() {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(6);
    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const [tableData, setTableData] = useState([]);
    const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const menuRefs = useRef(new Map());
    const navigate = useNavigate();
    const [showSuccess, setShowSuccess] = useState(false);
    const [downloadingPermitIds, setDownloadingPermitIds] = useState([]);
    const [qrLoadingIds, setQrLoadingIds] = useState([]);
    const [qrDialogVisible, setQrDialogVisible] = useState(false);
    const [qrCodeValue, setQrCodeValue] = useState(null);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const [editData, setEditData] = useState(null);
    const [searchFilters, setSearchFilters] = useState({
        vehicleNumber: '',
        cfxNumber: '',
        vehicleTypeId: null,
        startDate: null,
        endDate: null,
        permitNumber: '',
        paymentMethodId: null,
        requestStatusId: null,
    });
    const [vehivleList, setVehicleList] = useState()
    const [methodList, setMethodList] = useState()
    const [statusList , setStatusList]= useState()
    const [actionPerformed, setActionPerformed] = useState(false);
    const [isUsingFilters, setIsUsingFilters] = useState(false); // Add a state to track whether we're using filters or initial view


    const roleName = localStorage.getItem('roleName');

    const handleSearchFilterChange = (field, value) => {
        // Date validation
        if (field === 'startDate') {
            // If end date exists and the new start date is after the end date, show error
            if (searchFilters.endDate && value && value > searchFilters.endDate) {
                toast.error('Start date cannot be after end date');
                return;
            }
        } else if (field === 'endDate') {
            // If start date exists and the new end date is before the start date, show error
            if (searchFilters.startDate && value && value < searchFilters.startDate) {
                toast.error('End date cannot be before start date');
                return;
            }
        }
        
        setSearchFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSearch = () => {
        setPage(1);
        setFirst(0);
        setIsUsingFilters(true); // Set flag when search is performed
        fetchPermitDataWithFilters(1);
    };

    const handleClearSearch = () => {
        setSearchFilters({
            vehicleNumber: '',
            cfxNumber: '',
            vehicleTypeId: null,
            startDate: null,
            endDate: null,
            permitNumber: '',
            paymentMethodId: null,
            requestStatusId: null
        });
        setPage(1);
        setFirst(0);
        setIsUsingFilters(false); // Reset flag when search is cleared
        fetchPermitData(1);
    };

    const handleDelete = async (row) => {
        setShowSuccess(true);
        try {
            const response = await dispatch(handleDeleteRequest(`/api/Request/Delete?id=${row.id}`, true, true));
            if (response?.success) {
                setDeleteDialogVisible(false);
                setUserToDelete(null);
                fetchPermitData(page);
            }
        } catch (error) {
            console.error('Error deleting user:', error);
        } finally {
            setShowSuccess(false);
        }
    };

    const fetchPermitData = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            
            
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: null,
                vehicleTypeId: null,
                paymentMethodId: null,
                permitNumber: null,
                cfxNumber: null,
                startDate: currentDate, // Today's date for initial view
                endDate: currentDate,   // Today's date for initial view
                requestStatusId: null
            };

            const response = await dispatch(
                handlePostRequest(
                    requestBody,
                    '/api/permit/get',
                    false, 
                    false
                )
            );

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
                setIsUsingFilters(false); // Reset filter flag when using default view
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPermitDataWithFilters = async (pageNumber = 1) => {
        setLoading(true);
        try {
            const formatDate = (date) => {
                if (!date) return null;
                if (typeof date === 'string') return date;
                return date instanceof Date ? 
                    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : 
                    null;
            };
            
            
            const today = new Date();
            const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
            
            const DEFAULT_START_DATE = "2020-02-01";
            
            let startDate = searchFilters.startDate ? formatDate(searchFilters.startDate) : DEFAULT_START_DATE;
            let endDate = searchFilters.endDate ? formatDate(searchFilters.endDate) : currentDate;
            
            
           
            const requestBody = {
                pageNumber: pageNumber,
                pageSize: rows,
                vehicleNumber: searchFilters.vehicleNumber && searchFilters.vehicleNumber.trim() !== '' ? searchFilters.vehicleNumber : null,
                vehicleTypeId: searchFilters.vehicleTypeId === 0 ? 0 : (searchFilters.vehicleTypeId || null),
                paymentMethodId: searchFilters.paymentMethodId === 0 ? 0 : (searchFilters.paymentMethodId || null),
                permitNumber: searchFilters.permitNumber && searchFilters.permitNumber.trim() !== '' ? searchFilters.permitNumber : null,
                cfxNumber: searchFilters.cfxNumber && searchFilters.cfxNumber.trim() !== '' ? searchFilters.cfxNumber : null,
                startDate: startDate,
                endDate: endDate,
                requestStatusId: searchFilters.requestStatusId === 0 ? 0 : (searchFilters.requestStatusId || null)
            };
            

            const response = await dispatch(
                handlePostRequest(
                    requestBody,
                    '/api/permit/get',
                    false, 
                    false
                )
            );

            if (response?.success) {
                setTableData(response?.data?.records || []);
                setTotalRecords(response?.data?.pagination?.totalRecords || 0);
            }
            if (response?.false) {
                setTableData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching permit data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        setFirst(event.first);
        setRows(event.rows);
        setPage(newPage);
        
        // Use the appropriate fetch function based on isUsingFilters flag
        if (isUsingFilters) {
            fetchPermitDataWithFilters(newPage);
        } else {
            fetchPermitData(newPage);
        }
    };

    useEffect(() => {
        fetchPermitData(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEdit = (rowData) => {
        navigate(`/permit-requests/edit/${rowData.id}`);
    };

    const handleView = (rowData) => {
        setSidebarVisible(true)
        setEditData(rowData?.id);
    };



const handleShowQR = async (rowData) => {
    try {
        setQrLoadingIds(prev => [...prev, rowData.id]);
        
        const data = await handleGetRequest(`/api/permit/DQR/${rowData.id}`, false);
        
        if (data?.success) {
            setQrCodeValue(data.data); // { qrString, consumerId }
            setTimeout(() => {
                setQrDialogVisible(true);
            }, 100);
        } else {
            toast.error(data?.message || 'Failed to fetch QR code');
        }
    } catch (error) {
        console.error("Error fetching QR:", error);
        toast.error('Failed to load QR code: ' + (error.message || 'Unknown error'));
    } finally {
        setQrLoadingIds(prev => prev.filter(id => id !== rowData.id));
    }
};

const onHideDialog = () => {
    setQrDialogVisible(false);
    setQrCodeValue(null);
};

const handleIssuePermit = async (rowData) => {
    try {
        setDownloadingPermitIds((prev) => [...prev, rowData.id]);

        const response = await axios.get(`${baseURL}/api/permit/issue/${rowData?.id}`, {
            responseType: 'blob',
            headers: {
                Accept: 'application/pdf',
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });

        const blobURL = window.URL.createObjectURL(blob);

        window.open(blobURL);
    } catch (error) {
        toast.error('Failed to open permit');
    } finally {
        setDownloadingPermitIds((prev) => prev.filter((id) => id !== rowData.id));
    }
};


    // const handleIssuePermit = async (rowData) => {
    //     try {
    //         setDownloadingPermitIds((prev) => [...prev, rowData.id]);

    //         const response = await fetch(`${baseURL}/api/permit/${rowData.id}`, {
    //             method: 'GET',
    //             headers: {
    //                 Accept: 'application/pdf',
    //                 Authorization: `Bearer ${sessionStorage.getItem('token')}`
    //             }
    //         });
    //         if (!response.ok) {
    //             throw new Error('Failed to download PDF');
    //         }

    //         const blob = await response.blob();

    //         const contentDisposition = response.headers.get('Content-Disposition');
    //         let filename = `RoutePermit_${new Date().toISOString().slice(0, 10)}.pdf`;
    //         if (contentDisposition && contentDisposition.includes('filename=')) {
    //             const match = contentDisposition.match(/filename="?([^"]+)"?/);
    //             if (match && match[1]) {
    //                 filename = match[1];
    //             }
    //         }

    //         saveAs(blob, filename);
    //         toast.success('Route Permit downloaded successfully');
    //     } catch (error) {
    //         toast.error('Failed to download permit');
    //     } finally {
    //         setDownloadingPermitIds((prev) => prev.filter((id) => id !== rowData.id));
    //     }
    // };

    const actionBodyTemplate = (rowData) => {
        const isDownloading = downloadingPermitIds.includes(rowData.id);
        const isQrLoading = qrLoadingIds.includes(rowData.id);

        const items = [
            {
                label: 'View',
                icon: 'pi pi-eye',
                className: 'custom-view',
                command: () => handleView(rowData)
            },
            // Add QR Payment option for Approved but UnPaid permits that use client payment
            ...(
              rowData?.paymentStatus === "UnPaid" && 
              rowData?.paymentMethod === "Paid By Client" ? [
                {
                    label: 'QR',
                    icon: isQrLoading ? 'pi pi-spinner pi-spin' : 'pi pi-qrcode',
                    className: 'custom-qr-payment',
                    disabled: isQrLoading,
                    command: () => {
                        if (!isQrLoading) {
                            handleShowQR(rowData);
                        }
                    }
                }
            ] : []),
            // {
            //     label: 'Edit',
            //     icon: 'pi pi-pencil',
            //     className: 'custom-edit',
            //     command: () => handleEdit(rowData)
            // },
            ...(rowData?.requestStatus === 'Approved'
                ? [
                      {
                          label: 'Issue',
                          icon: 'pi pi-download',
                          className: 'custom-Issue',
                          disabled: isDownloading,
                          command: () => {
                              if (!isDownloading) {
                                  handleIssuePermit(rowData);
                              }
                          }
                      }
                  ]
                : []),
            ...((rowData.requestStatus === 'Pending' || rowData.requestStatus === 'Rejected') && roleName === 'Data Entry Operator'
                ? [
                      {
                          label: 'Edit',
                          icon: 'pi pi-pencil',
                          className: 'custom-edit',
                          command: () => handleEdit(rowData)
                      },
                    //   {
                    //       label: 'Delete',
                    //       icon: 'pi pi-trash',
                    //       className: 'custom-delete text-red-600',
                    //       command: () => {
                    //           setUserToDelete(rowData);
                    //           setDeleteDialogVisible(true);
                    //       }
                    //   }
                  ]
                : [])
        ];

        if (!menuRefs.current.has(rowData.id)) {
            menuRefs.current.set(rowData.id, React.createRef());
        }
        const rowMenuRef = menuRefs.current.get(rowData.id);

        return (
            <div>
                <Menu model={items} popup ref={rowMenuRef} />
                <Button
                    icon={isDownloading ? 'pi pi-spinner pi-spin' : 'pi pi-ellipsis-h'}
                    className="p-button p-0 m-0 bg-white border-none shadow-none hover:bg-gray-100 custom-icon-black"
                    style={{ boxShadow: 'none' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (!isDownloading) {
                            rowMenuRef.current.toggle(e);
                        }
                    }}
                    disabled={isDownloading}
                />
            </div>
        );
    };

    const template1 = {
        layout: 'CurrentPageReport',
        CurrentPageReport: (options) => {
            return (
                <span style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'left', fontSize: '12px', fontWeight: '400' }}>
                    Showing{' '}
                    <span style={{ fontWeight: '700' }}>
                        {options.first} - {Math.min(options.first + options.rows - 1, options.totalRecords)}
                    </span>{' '}
                    from <span style={{ fontWeight: '700' }}>{options.totalRecords}</span> records
                </span>
            );
        }
    };

    const template2 = {
        layout: 'PrevPageLink PageLinks NextPageLink',
        PrevPageLink: (options) => {
            return <Button icon="pi pi-chevron-left" className="p-button prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        },
        PageLinks: (options) => {
            const isActive = options.currentPage === options.page;
            return (
                <button
                    type="button"
                    className={`mx-1 px-4 py-2 ${isActive ? 'isActivePage' : 'notActivePage'}`}
                    onClick={options.onClick}
                    style={{
                        width: '40.08px',
                        height: '40.08px',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        margin: '2px',
                        border: 'none',
                        boxShadow: isActive ? '0px 7px 16px 0px #00000024' : 'none'
                    }}
                >
                    {options.page + 1}
                </button>
            );
        },
        NextPageLink: (options) => {
            return <Button icon="pi pi-chevron-right" className="p-button-text prev-page-link" onClick={options.onClick} disabled={options.disabled} />;
        }
    };

   useEffect(() => {
    // Only run when actionPerformed becomes true
    if (actionPerformed) {
        console.log("Action was performed, refreshing data...");
        
        // Get the current page for refresh - don't reset to page 1
        const currentPageNumber = page;
        
        // If we were using filters before the action, refresh with filters
        // Otherwise use the regular fetch
        if (isUsingFilters) {
            fetchPermitDataWithFilters(currentPageNumber);
        } else {
            fetchPermitData(currentPageNumber);
        }
        
        // Reset the action performed flag
        setActionPerformed(false);
    }
   // eslint-disable-next-line react-hooks/exhaustive-deps
}, [actionPerformed, page, isUsingFilters]);

 const onHideSidebar = () => {
    // First close the sidebar
    setSidebarVisible(false);
    setEditData(null);
    
   };

    const getStatusSeverity = (status) => {
        switch (status) {
            case 'Pending':
                return 'info';
            case 'Approved':
                return 'success';
            case 'Rejected':
                return 'danger';
            case 'Completed':
                return 'warning';
            default:
                return 'info';
        }
    };

    const getPaymentStatusSeverity = (status) => {
        switch (status) {
            case 'Cash In Hand':
                return 'warning';
            case 'Paid By Client':
                return 'info';
            case 'Paid By Officer':
                return 'success';
            default:
                return 'info';
        }
    };

    const statusBodyTemplate = (rowData) => {
        return <Tag value={rowData.paymentStatus} severity={getStatusSeverity(rowData.paymentStatus)} />;
    };

    const paymentStatusBodyTemplate = (rowData) => {
        return <Tag value={rowData.paymentMethod} severity={getPaymentStatusSeverity(rowData.paymentMethod)} />;
    };

    const isRenewBodyTemplate = (rowData) => {
        return rowData.isRenew ? 'Renew' : 'New';
    };

    const createdOnBodyTemplate = (rowData) => {
        const date = new Date(rowData.createdOn);
        return date.toLocaleDateString(); 
    };


    const getLovsData = async () => {
        const vehiclesData = await handleGetRequest('/api/dropdown/vehicles', false)
        if (vehiclesData?.success) {
            setVehicleList(vehiclesData?.data)
        }
        const methodsData = await handleGetRequest('/api/dropdown/payment/method', false);
        if (methodsData?.success) {
            setMethodList(methodsData?.data);
        }
        const statusData = await handleGetRequest('/api/dropdown/request/status', false);
        if (statusData?.success) {
            setStatusList(statusData?.data);
        }
    }

    useEffect(() => {
        getLovsData()
    }, [])

       const handleExcel = async () => {
           try {
               setLoading(true);

               // Format dates to "YYYY-MM-DD" format for API
               const formatDate = (date) => {
                   if (!date) return null;
                   if (typeof date === 'string') return date;
                   return date instanceof Date ? 
                       `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : 
                       null;
               };
               

               // Get current date for default end date
               const today = new Date();
               const currentDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
               
               // Default start date if not provided by user
               const DEFAULT_START_DATE = "2020-02-01";
               
               // Use defaults if dates not selected
               const startDate = searchFilters?.startDate ? formatDate(searchFilters?.startDate) : DEFAULT_START_DATE;
               const endDate = searchFilters?.endDate ? formatDate(searchFilters?.endDate) : currentDate;
               
               const data = {
                   vehicleNumber: searchFilters?.vehicleNumber && searchFilters.vehicleNumber.trim() !== '' ? searchFilters.vehicleNumber : null,
                   cfxNumber: searchFilters?.cfxNumber && searchFilters.cfxNumber.trim() !== '' ? searchFilters.cfxNumber : null,
                   vehicleTypeId: searchFilters?.vehicleTypeId === 0 ? 0 : (searchFilters?.vehicleTypeId || null),
                   paymentMethodId: searchFilters?.paymentMethodId === 0 ? 0 : (searchFilters?.paymentMethodId || null),
                   startDate: startDate,
                   endDate: endDate,
                   requestStatusId: searchFilters?.requestStatusId === 0 ? 0 : (searchFilters?.requestStatusId || null)
               };
               const response = await fetch(`${baseURL}/api/report/permit/excel`, {
                   method: 'POST',
                   headers: {
                       'Content-Type': 'application/json',
                       Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                       Authorization: `Bearer ${sessionStorage.getItem('token')}`
                   },
                   body: JSON.stringify(data)
               });

               const contentDisposition = response.headers.get('Content-Disposition');
               const filename = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : `PermitRequests_${new Date().toISOString().slice(0, 10)}.xlsx`;

               const blob = await response.blob();

               const url = window.URL.createObjectURL(blob);
               const a = document.createElement('a');
               a.href = url;
               a.download = filename;
               document.body.appendChild(a);
               a.click();
               window.URL.revokeObjectURL(url);
               document.body.removeChild(a);

               toast.current.show({
                   severity: 'success',
                   summary: 'Success',
                   detail: 'Report exported successfully',
                   life: 3000
               });
           } catch (error) {
               console.error('Error downloading Excel report:', error);
           } finally {
               setLoading(false);
           }
       };

    return (
        <>
            {showSuccess && <SuccessLoader />}
            <Sidebar
                // className="p-sidebar-md"
                visible={sidebarVisible}
                position="right"
                onHide={onHideSidebar}
                style={{ width: '581px' }}
                pt={{
                    header: { className: 'border-bottom-1' },
                    content: { className: 'p-0' }
                }}
                showCloseIcon={false}
                blockScroll={true}
                className="renewal-sidebar"
            >
                <PermitViewSideBar onHideSidebar={onHideSidebar} editData={editData} onActionPerformed={() => {
            console.log("Setting actionPerformed to true");
            setActionPerformed(true);
        }}  />
            </Sidebar>
            <ConfirmDialog
                visible={deleteDialogVisible}
                onHide={() => setDeleteDialogVisible(false)}
                message="Are you sure you want to delete this route permit request?"
                contentClassName="content-className"
                header="Delete Permit Request"
                headerClassName="text-black"
                icon={<img src={DeleteIcon} alt="Delete" />}
                acceptLabel="Sure"
                rejectLabel="Close"
                acceptClassName="accept-button"
                rejectClassName="reject-button"
                className="custom-confirm-dialog"
                accept={() => handleDelete(userToDelete)}
            />
            <div className="grid">
                <div className="col-12 flex flex-column">
                    <div className="flex justify-content-between items-center">
                        <h2 className="text-lg font-semibold">Permit Request Management</h2>
                        <div className="flex items-center gap-2">
                            {/* <span className="p-input-icon-left">
                                <i className="pi pi-search" />
                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." className="p-inputtext-sm rounded-input" />
                            </span> */}
                            <Button label="Download Excel" onClick={handleExcel} style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }} />
                            {roleName === 'Data Entry Operator' && (
                                <Button
                                    label="Add New"
                                    icon="pi pi-plus"
                                    className="px-4 py-2 font-semibold"
                                    style={{ backgroundColor: '#FF556A', border: 'none', borderRadius: '10px' }}
                                    onClick={() => {
                                        navigate('/permit-requests/add');
                                    }}
                                />
                            )}
                        </div>
                    </div>

                    {/* Search Filters Section */}
                    <div className="mt-3 p-3 border-1 surface-border border-round">
                        <div className="grid">
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="vehicleNumber" value={searchFilters.vehicleNumber} onChange={(e) => handleSearchFilterChange('vehicleNumber', e.target.value)} placeholder="Enter vehicle number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText id="cfxNumber" value={searchFilters.cfxNumber} onChange={(e) => handleSearchFilterChange('cfxNumber', e.target.value)} placeholder="Enter CFX number" className="Input__Round" />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <InputText
                                        id="permitNumber"
                                        name="permitNumber"
                                        value={searchFilters.permitNumber}
                                        onChange={(e) => handleSearchFilterChange('permitNumber', e.target.value)}
                                        placeholder="Enter permit number"
                                        className="Input__Round"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={vehivleList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="vehicleTypeId"
                                        name="vehicleTypeId"
                                        value={searchFilters.vehicleTypeId}
                                        onChange={(e) => handleSearchFilterChange('vehicleTypeId', e.value)}
                                        placeholder="Select Vehicle Category"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={methodList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="paymentMethodId"
                                        value={searchFilters.paymentMethodId}
                                        onChange={(e) => handleSearchFilterChange('paymentMethodId', e.value)}
                                        placeholder="Select Payment Method"
                                        className="Dropdown__Round"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Dropdown
                                        options={statusList}
                                        optionValue="id"
                                        optionLabel="name"
                                        id="requestStatusId"
                                        value={searchFilters.requestStatusId}
                                        onChange={(e) => handleSearchFilterChange('requestStatusId', e.value)}
                                        placeholder="Select Status"
                                        className="Dropdown__Round w-full"
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Calendar
                                        id="startDate"
                                        name="startDate"
                                        placeholder="Select start date"
                                        dateFormat="mm/dd/yy"
                                        value={searchFilters.startDate}
                                        onChange={(e) => handleSearchFilterChange('startDate', e.value)}
                                        // className="Input__Round w-full"
                                        // showIcon
                                        inputClassName="Input__Round"
                                        maxDate={searchFilters.endDate || undefined}
                                        // tooltip="Start date must be before end date"
                                        // showButtonBar
                                        // readOnlyInput
                                    />
                                </span>
                            </div>
                            <div className="col-12 md:col-3">
                                <span className="p-input-icon-left">
                                    <Calendar
                                        id="endDate"
                                        name="endDate"
                                        placeholder="Select end date"
                                        dateFormat="mm/dd/yy"
                                        value={searchFilters.endDate}
                                        onChange={(e) => handleSearchFilterChange('endDate', e.value)}
                                        // className="Input__Round w-full"
                                        // showIcon
                                        inputClassName="Input__Round"
                                        minDate={searchFilters.startDate || undefined}
                                        // tooltip="End date must be after start date"
                                        // showButtonBar
                                        // readOnlyInput
                                    />
                                </span>
                            </div>
                        </div>
                        <div className="flex justify-content-end gap-2 mt-3">
                            <Button label="Search" icon="pi pi-search" className="px-4 py-2 font-semibold" style={{ backgroundColor: '#ff556a', border: 'none', borderRadius: '10px' }} onClick={handleSearch} />
                            <Button label="Clear" icon="pi pi-times" className="px-4 py-2 font-semibold" style={{ borderRadius: '10px', backgroundColor: '#ff556a', border: 'none' }} onClick={handleClearSearch} />
                        </div>
                    </div>
                    <div className="card mt-3">
                        {/* <DataTable value={tableData} className="datatable-responsive shadow-md rounded-xl" loading={loading}> */}
                        <DataTable
                            value={tableData}
                            loading={loading}
                            responsiveLayout="scroll"
                            className="datatable-responsive shadow-md rounded-xl"
                            scrollable
                            scrollHeight="45vh"
                            stickyHeader
                               emptyMessage={
        <div className="w-full text-center">
            No results found
        </div>
                               }
                            >
                            <Column field="regNum" header="Reg No." />
                            <Column field="vehicleType" header="Vehicle Category" />
                            <Column field="permitNum" header="Permit No." />
                            {/* <Column field="fitnessCFX" header="CFX #" /> */}
                            {/* <Column field="createdOn" header="Created On" body={createdOnBodyTemplate} /> */}
                            <Column field="requestDate" header="Request Date" />
                            <Column
                                field="requestStatus"
                                header="Request Status"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${
                                            rowData.requestStatus === 'Approved'
                                                ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                : rowData.requestStatus === 'Pending'
                                                ? 'bg-[#FFEFE9] text-[#FFEFE9] Inactive-column-cc'
                                                : rowData.requestStatus === 'Rejected'
                                                ? 'bg-[##FFFFE0] text-[#FF8F6B] Inactive-column'
                                                : ''
                                        }`}
                                    >
                                        {rowData.requestStatus}
                                    </div>
                                )}
                            />
                            <Column field="totalAmount" align="center" header="Total Amount" />
                            <Column
                                field="paymentMethod"
                                header="Payment Method"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${
                                            rowData.paymentMethod === 'Paid By Client'
                                                ? 'bg-[#E6F4EA] text-[#3A974C] Active-column'
                                                : rowData.paymentMethod === 'Paid By Officer'
                                                ? 'bg-[#FFEFE9] text-[#FFEFE9] Inactive-column-cc'
                                                : rowData.paymentMethod === 'Cash In Hand'
                                                ? 'bg-[##FFFFE0] text-[#FF8F6B] Inactive-column'
                                                : ''
                                        }`}
                                    >
                                        {rowData.paymentMethod}
                                    </div>
                                )}
                                style={{ minWidth: '15%' }}
                            />
                            {/* <Column field="isRenew" header="Request Type" body={isRenewBodyTemplate} /> */}
                            <Column
                                field="paymentStatus"
                                header="Payment Status"
                                align="center"
                                body={(rowData) => (
                                    <div
                                        className={`py-1 rounded-full text-sm font-semibold flex justify-content-center items-center ${
                                            rowData.paymentStatus === 'Paid' ? 'bg-[#E6F4EA] text-[#3A974C] Active-column' : rowData.paymentStatus === 'UnPaid' ? 'bg-[#FFEFE9] text-[#FF8F6B] Inactive-column' : ''
                                        }`}
                                    >
                                        {rowData.paymentStatus}
                                    </div>
                                )}
                            />
                            <Column body={actionBodyTemplate} style={{ width: '4rem' }} />
                        </DataTable>
                        <div className="flex justify-content-between mt-1" style={{borderTop: '1px solid #efefef' }}>
                            <Paginator template={template1} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" />
                            <Paginator template={template2} first={first} rows={rows} totalRecords={totalRecords} onPageChange={onPageChange} rowsPerPageOptions={[10, 25, 50]} />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                header={
                    <div className="flex justify-content-between align-items-center px-4 py-2" style={{ height: '80px' }}>
                        <h3 className="m-0">QR Code Payment</h3>
                        <Button icon="pi pi-times" className="p-button-rounded p-button-text" onClick={onHideDialog} />
                    </div>
                }
                visible={qrDialogVisible}
                closable={true}
                onHide={onHideDialog}
                className="image-dialog qr-dialog"
                style={{ width: '90vw', maxWidth: '600px', borderRadius: '12px', zIndex: 1100 }}
                contentStyle={{ padding: '2rem', borderRadius: '0 0 12px 12px' }}
                modal={true}
                dismissableMask={true}
            >
                {qrCodeValue ? (
                    <div className="flex flex-column align-items-center text-center">
                        <h4 className="mb-3 font-medium text-gray-800">Scan QR Code for Online Payment</h4>
                        <div className="my-3 bg-gray-100 p-6 rounded-lg">
                            <QRCode value={qrCodeValue?.qrString} size={256} />
                        </div>
                        <p className="text-sm text-gray-600">
                            Use QR Code or Consumer ID: <strong>{qrCodeValue?.consumerId}</strong> to complete your payment.
                        </p>
                        <Button label="Close" onClick={onHideDialog} className="mt-4 p-button-secondary" style={{ borderRadius: '6px', padding: '0.75rem 2rem' }} />
                    </div>
                ) : (
                    <p className="text-center text-sm text-red-500">No QR data returned.</p>
                )}
            </Dialog>
        </>
    );
}

export default PermitManagement;
